export default {
  sm: `
  DATA CENTER GAK's advanced
  technologies are a prerequisite
  for tomorrow's innovations.
  `,
  md: `
  DATA CENTER GAK's advanced 
  technologies are a prerequisite for 
  tomorrow's innovations.
  `,
  lg: `
  DATA CENTER GAK's advanced technologies 
  are a prerequisite for tomorrow's innovations.
  `,
};
